import { PageHero, CTABand } from "@/components/PageHero";
import { Reveal, ParallaxImg } from "@/components/anim";
import { IMG } from "@/lib/img";

const EVENT_TYPES = [
  "Product launches",
  "Sip & Shops",
  "Trunk shows",
  "Workshops",
  "Small networking events",
  "Beauty events",
  "Private shopping events",
  "Brand activations",
  "Content creation",
  "Influencer events",
  "Pop-up experiences",
  "Creative workshops",
];

export default function Events() {
  return (
    <>
      <PageHero
        eyebrow="Events & Creative Space"
        lines={[
          <>More Than</>,
          <>
            A <em>Store.</em>
          </>,
        ]}
        sub="Essandtials is a venue for experiences — launch your product, gather your community, create your content, and make the moment feel like a real brand."
      />

      <section className="bg-paper pb-24 sm:pb-32" data-testid="events-types">
        <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
          <div className="grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-beige/60 bg-beige/60 sm:grid-cols-2 lg:grid-cols-3">
            {EVENT_TYPES.map((e, i) => (
              <Reveal key={e} delay={i * 0.04} className="bg-paper p-8">
                <p className="font-serif text-sm italic text-sanddeep">
                  {String(i + 1).padStart(2, "0")}
                </p>
                <p className="mt-4 font-serif text-xl uppercase text-ink sm:text-2xl">{e}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-sand py-24 sm:py-32" data-testid="events-showcase">
        <div className="mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-14 px-6 lg:grid-cols-2 lg:gap-20 lg:px-10">
          <ParallaxImg
            src={IMG.eventColumns}
            alt="Minimalist event space"
            className="aspect-[4/5] w-full rounded-3xl shadow-[0_30px_80px_rgba(26,24,23,0.12)]"
          />
          <div>
            <ParallaxImg
              src={IMG.workshopCraft}
              alt="Creative workshop around a table"
              className="aspect-[16/10] w-full rounded-3xl shadow-[0_20px_60px_rgba(26,24,23,0.12)]"
            />
            <p className="mt-8 max-w-lg font-serif text-2xl italic leading-snug text-ink">
              &ldquo;More than a store — a stage for Bermuda&rsquo;s brands.&rdquo;
            </p>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-clay sm:text-base">
              From an intimate workshop to a full brand activation, the space transforms around
              your idea. Tell us what you&rsquo;re imagining and we&rsquo;ll help you make it
              happen.
            </p>
          </div>
        </div>
      </section>

      <CTABand
        title={
          <>
            Let&rsquo;s make it
            <br />
            <em>an occasion.</em>
          </>
        }
        cta="Host Your Event"
        to="/book?type=Private%20Event"
        testid="events-book-button"
      />
    </>
  );
}
